angular.module('common.directives.slideInBounce', [])

    .directive("slideInBounce", function ($animate, $timeout) {
            return ({
                restrict: 'A',
                scope: {
                },
                link: function (scope, element, attrs) {
                    var el = $(element);
                    
                    $timeout(function () {
                        scope.$applyAsync(function () {

                            el.stop(true, false);
                            el.css('position', 'relative');
                            el.css('opacity', 0);
                            el.css("top", -50); //initial offset (TODO: think on exporting as a parameter, as well as direction of animation)
                            animateElement(el, 0, 400, "easeOutBounce"); // initial animation
                        });
                    }, 10);
                }
            });

        function animateElement(element, offset, duration, easing) {
            if (parseInt(offset) == null) {
                return;
            }

            element.stop(true, false);
            element.animate(
                {
                    top: offset || 0,
                    opacity: 1
                },
                duration || 400,
                easing || "easeInOutExpo",
                function () {
                    
                });
        }
        }
    );
